export default "__VITE_ASSET__Dbf_GlBN__"